/* global __API_ROOT_URL__ */
import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


let _$http;
let _upload;
let _utilityService;

export class eduDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _upload = Upload;
    _utilityService = utilityService;

    console.log('app.services.eduDataService created');
  }

  getTopics() {
    return _$http({
      url: `${__API_ROOT_URL__}/edu/media`,
      method: 'GET',
    });
  }

  saveMedia(sectionId, media, thumbnail, files) {
    let _url = `${__API_ROOT_URL__}/edu/media`;
    let _method = 'POST';

    if (media.mediaId > 0) {
      _url = `${__API_ROOT_URL__}/edu/media/${media.mediaId}`;
      _method = 'PUT';
    }

    return _upload.upload({
      url: _url,
      method: _method,
      data: {
        sectionId,
        media: JSON.stringify(media),
        files,
        echo: true,
        thumbnail
      }
    });
  }

  saveMediaSortOrder(sectionId, mediaKeySortOrderValue) {
    return _$http({
      url: `${__API_ROOT_URL__}/edu/sectionMedia/updateSortOrder`,
      method: 'PUT',
      data: _utilityService.serializeData({
        sectionId,
        mediaSortOrder: JSON.stringify(mediaKeySortOrderValue),
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  logMediaActivity(mediaId) {
    return _$http({
      url: `${__API_ROOT_URL__}/edu/sectionMedia/${mediaId}/logActivity`,
      method: 'PUT',
    });
  }

  deleteMedia(mediaId) {
    return _$http({
      url: `${__API_ROOT_URL__}/edu/media/${mediaId}`,
      method: 'DELETE',
    });
  }

  downloadDocument(documentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/${documentId}?callingComponent=training`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }
}

eduDataService.$inject = ['$http', 'Upload', 'utilityService'];
export default angular.module('app.services.eduDataService', [
  ngFileUpload,
  constants,
])
  .service('eduDataService', eduDataService)
  .name;
